import React, { memo } from "react";

import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { DELAYED_SUCCESS_CONSTANTS } from "./constant";
import { ContentContainer, LoaderContainer, TitleContainer, SubtitleContainer } from "./styled";
import { IDelayedSuccessHalfCardProps } from "./types";

const DelayedSuccessHalfCard = memo(({ show }: IDelayedSuccessHalfCardProps) => {
    return (
        <HalfCard
            isOpen={show}
            closeOnOverlayClick={false}
            hideCloseIcon={true}
            hasCustomPadding={true}
            positionFromBottom={0}
        >
            <ContentContainer>
                <LoaderContainer>
                    <Loader
                        type="primary"
                        backgroundColor="background_Button_Secondary"
                        foregroundColor="primary"
                        size={DELAYED_SUCCESS_CONSTANTS.LOADER_SIZE}
                    />
                </LoaderContainer>

                <TitleContainer>
                    <Text variant="V2.heading1.neutral.black" color="text_Highest_Emphasis">
                        {DELAYED_SUCCESS_CONSTANTS.TITLE}
                    </Text>
                </TitleContainer>

                <SubtitleContainer>
                    <Text variant="V2.body1.neutral.regular" color="text_Low_Emphasis">
                        {DELAYED_SUCCESS_CONSTANTS.SUBTITLE}
                    </Text>
                </SubtitleContainer>
            </ContentContainer>
        </HalfCard>
    );
});

DelayedSuccessHalfCard.displayName = "DelayedSuccessHalfCard";

export default DelayedSuccessHalfCard;
